import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, actions } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import {
    OR_RRF_TextArea as TextArea
    , OR_RRF_Select as Select
    , ORFButton as Button
} from '../../../../../common/forms/order-request-form.component';
import { newMobileSubscriptionActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireless-request/new-mobile-subscription.reducer";
import { TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import './wireless-location-form.component.css';
import { createRequestActions } from "../../../../../../store/external/request-reducer/create-request.reducer";
import { requestDetailsActions } from "../../../../../../store/external/request-reducer/request-details.reducer";
import CustomSearchableSelectWrapper from '../../../../../common/custom-form/custom-searchable-select-wrapper.component';
import { MAX_LENGTH } from '../../../../../../constants/external-constants';

class WirelessLocationFormA extends Component {
   
    componentDidMountstate() {
        this.handleDisableAutoScroll()
        if (!this.props.wirelessLocationFormA.isAmending) {
            this.props.onCountrySelect("wirelessLocationFormA.countryCode", this.props.wirelessLocationFormA.countryCode);
        }
    }


    componentDidMount() {
        this.handleDisableAutoScroll();
    }

    handleDisableAutoScroll=()=>{
        if(this.props.wirelessLocationFormA.locationId !== -1){
            this.props.disableAutoScroll(true);
        } else{
            this.props.disableAutoScroll(false);
        } 
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }
    handleChange = (field, value) =>{
        if(value !== -1){
            this.props.disableAutoScroll(true);
        } else{
            this.props.disableAutoScroll(false);
        } 
        this.props.onAddressSelect(field, value);
    }
    render() {
        const {
            //component props
            nextAction, onClickCancel
            // form
            , wirelessLocationFormA
            // reducer action
            , setRequestorAddress            
            , onAddressSelect
        } = this.props;

        const { countryOptions, addressOptions } = this.props.newMobileRequest;
        const { isRequestOnBehalf, requestOnBehalfData } = this.props.createRequest;
        let isROB = isRequestOnBehalf && (requestOnBehalfData.EmployeeId === '' || requestOnBehalfData.EmployeeId === 0)
        let showPreferredAddress = wirelessLocationFormA.locationId.toString() === "-1";
        let disable = wirelessLocationFormA.countryCode === ''
            || wirelessLocationFormA.locationId === '' || isROB;

        if (showPreferredAddress) {
            disable = disable || wirelessLocationFormA.otherDeliveryAddress === '';
        }
        
        return (
            <div >
                <Form method="post" role="form"
                    model="wirelessLocationFormA"
                    onSubmit={nextAction}
                >
                    <Row>
                        <div className='use-request-container'>
                             <span onClick={setRequestorAddress} className="requestor-address-link">{this.toLocaleLanguage('use_requestor_address')}</span>
                        </div>
                        <Col xs={12} md={12} lg={12} className='required custom-wrapper-plan custom-margin'>
                            <CustomSearchableSelectWrapper
                                label={`${this.toLocaleLanguage('country')}`}
                                options={countryOptions}
                                selected={wirelessLocationFormA.countryCode}
                                onChange={(e) => onAddressSelect('wirelessLocationFormA.countryCode', e)}
                                placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                fieldProp='.countryCode'
                                maxLength={MAX_LENGTH.limit_100}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='requesto-info-container required'>                           
                            <CustomSearchableSelectWrapper
                                label={`${this.toLocaleLanguage('delivery_address')}`}
                                options={addressOptions}
                                selected={wirelessLocationFormA.locationId}
                                onChange={(e) => this.handleChange('wirelessLocationFormA.locationId', e)}
                                placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                fieldProp='.locationId'
                                maxLength={MAX_LENGTH.limit_500}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                
                            />
                             {
                                wirelessLocationFormA.deliveryAddress !== '' && !disable &&
                                <div className={`delivery-address-label ${showPreferredAddress ? "mb-3" : ""}`}>
                                    {wirelessLocationFormA.deliveryAddress}
                                </div>
                        }
                        </Col>                       
                    </Row>
                   
                    {showPreferredAddress &&
                        <Row className='margin-top-20'>
                            <Col xs={12} md={12} lg={12} className='requesto-info-container required'>
                            <TextArea
                                maxLength={MAX_LENGTH.limit_255}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                label={`${this.toLocaleLanguage('preferred_delivery_address')}`}
                                    fieldProp='.otherDeliveryAddress'
                                    value={wirelessLocationFormA.otherDeliveryAddress} />
                            </Col>
                        </Row>
                    }
                    <div className="request-button-continer margin-top-25">
                        <div className="bottom-left">
                            <Button
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            {
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('next_button')}
                                        type={"submit"}
                                        variant={"primary"}
                                        disabled={disable}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { newMobileRequest, createRequest, translation } = state;
        const { wirelessLocationFormA } = state.form;
        return {
            newMobileRequest
            , createRequest
            , wirelessLocationFormA
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newMobileSubscriptionActions, createRequestActions, requestDetailsActions),
            dispatch
        )
)(WirelessLocationFormA);